import { Component, Host, h, Prop, Event, type EventEmitter } from '@stencil/core'

@Component({
  tag: 'cobalt-checkbox',
  styleUrl: 'cobalt-checkbox.css'
})
export class CobaltCheckbox {
  /**
   * The label that accompany the checkbox. It is **required** for accessibility concerns.
   */
  @Prop({ mutable: true, reflect: true }) label!: string
  /**
   * The immutable value sent in the payload as identifier. It is **required**.
   */
  @Prop({ reflect: true }) value!: string
  /**
   * Description will append below the label.
   */
  @Prop({ mutable: true }) description?: string
  /**
   * A string indicating the position of the label or if it is hidden.
   */
  @Prop({ mutable: true }) format?: 'right' | 'left' | 'hidden' = 'right'
  /**
   * A Boolean indicating whether the box is checked or unchecked.
   *
   * It should be false if the checkbox is `indeterminate`.
   */
  @Prop({ mutable: true, reflect: true }) checked?: boolean = false
  /**
   * A Boolean indicating whether the box is indeterminate or not.
   *
   * It should be false if the checkbox is `checked`.
   */
  @Prop({ mutable: true }) indeterminate?: boolean = false
  /**
   * A boolean indicating the disable state of the checkbox. The `aria-disabled` attribute relies on this property.
   */
  @Prop({ mutable: true, reflect: true }) disabled?: boolean = false

  /**
   * Emitted when the checked value has changed.
   */
  @Event() cobaltCheckboxChange: EventEmitter

  handleCheck = (): void => {
    if (this.disabled) return
    this.checked = !this.checked
    if (this.checked) this.indeterminate = false
    this.cobaltCheckboxChange.emit({ value: this.value, checked: this.checked })
  }

  render(): any {
    return (
      <Host>
        <core-checkbox
          label={this.label}
          value={this.value}
          description={this.description}
          format={this.format}
          checked={this.checked}
          indeterminate={this.indeterminate}
          disabled={this.disabled}
          onCoreCheckboxChange={this.handleCheck}
        ></core-checkbox>
      </Host>
    )
  }
}
